<template>
  <div>
    <splide :options="options" @splide:click="handleSlideClick">
      <splide-slide
        v-for="(slide, i) in slides"
        :key="slide.id"
        :data-index="i"
        class="slide"
        :style="{
          'background-color': slide.color,
          'background-image': `url(${slide.image})`,
          'background-position': slide.position || 'center',
        }"
      >
        <div
          class="max-w-6xl mx-auto h-full px-6 md:px-0 text-white"
          v-html="slide.body"
        ></div>
      </splide-slide>
    </splide>
  </div>
</template>

<script>
import { Splide, SplideSlide } from '@splidejs/vue-splide'
import '@splidejs/splide/dist/css/themes/splide-default.min.css'

export default {
  components: {
    Splide,
    SplideSlide,
  },

  props: {
    slides: Array,
  },

  data: () => ({
    options: {
      rewind: true,
      perPage: 1,
      autoplay: true,
      pauseOnHover: false,
    },
  }),

  methods: {
    handleSlideClick(splide) {
      const link = this.slides[splide.index].link
      if (!link) {
        return
      }
      window.location.href = link
    },
  },
}
</script>
